import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import {
	TbLayoutSidebarLeftCollapse,
	TbLayoutSidebarLeftExpand,
} from 'react-icons/tb';
import { useCanvasFullscreenToggle } from 'src/hooks/useCanvasFullscreenToggle';

interface canvasFullScreenToggleButtonProps {
	sx?: any;
}

export const CanvasFullScreenToggleButton: React.FC<
	canvasFullScreenToggleButtonProps
> = ({ sx = {} }) => {
	const { isCanvasFullscreen, toggleCanvasFullscreen } =
		useCanvasFullscreenToggle();

	return (
		<Tooltip
			title={isCanvasFullscreen ? 'Minimise Canvas' : 'Expand Canvas'}
			arrow
		>
			<IconButton
				onClick={toggleCanvasFullscreen}
				sx={{
					p: 1,
					border: '1px solid',
					borderColor: 'divider',
					bgcolor: 'background.paper',
					color: 'text.secondary',
					'&:hover': {
						bgcolor: 'action.hover',
						borderColor: 'action.focus',
					},
					transition: 'all 0.2s ease-in-out',
					...sx,
				}}
				aria-label={isCanvasFullscreen ? 'Expand sidebar' : 'Collapse sidebar'}
			>
				{isCanvasFullscreen ? (
					<TbLayoutSidebarLeftExpand size={20} />
				) : (
					<TbLayoutSidebarLeftCollapse size={20} />
				)}
			</IconButton>
		</Tooltip>
	);
};
